import { Component, inject } from '@angular/core';
import { SsbKonfigService } from '@features/ssb-konfiguration/ssb-konfig.service';
import { PrimeTemplate } from 'primeng/api';
import { TableModule } from 'primeng/table';
import { TableRowDirective } from '@core/primevue/directives/table-row.directive';

@Component({
  selector: 'app-ssb-konfig-result',
  imports: [
    PrimeTemplate,
    TableModule,
    TableRowDirective
  ],
  templateUrl: './ssb-konfig-result.component.html',
  styleUrl: './ssb-konfig-result.component.css'
})
export class SsbKonfigResultComponent {
  ssbKonfigService = inject(SsbKonfigService);


}
